var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderConstruct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.566 30.3433L31.808 26.1013L43.7999 38.0933L39.5579 42.3353L27.566 30.3433ZM35 19.9993C38.86 19.9993 42 16.8593 42 12.9993C42 11.8393 41.68 10.7593 41.18 9.79933L35.7799 15.1993L32.7999 12.2193L38.2 6.81933C37.24 6.31933 36.16 5.99933 35 5.99933C31.14 5.99933 28 9.13933 28 12.9993C28 13.8193 28.16 14.5993 28.42 15.3193L24.72 19.0193L21.16 15.4593L22.58 14.0393L19.76 11.2193L24 6.97933C22.8749 5.85573 21.35 5.22461 19.76 5.22461C18.1699 5.22461 16.645 5.85573 15.52 6.97933L8.43995 14.0593L11.26 16.8793H5.61995L4.19995 18.2993L11.28 25.3793L12.7 23.9593V18.2993L15.52 21.1193L16.94 19.6993L20.5 23.2593L5.67995 38.0793L9.91995 42.3193L32.68 19.5793C33.4 19.8393 34.18 19.9993 35 19.9993Z",
    fill: "#FCC046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstruct);
export default __webpack_public_path__ + "static/media/underConstruct.a32e3d970439538c56b286047ee77ca1.svg";
export { ForwardRef as ReactComponent };